import Address from '../../../../components/address'
import Breadcrumb from '../../../../components/breadcrumb'
import Col from 'react-bootstrap/lib/Col'
import Link from 'react-router/lib/Link'
import PropTypes from 'prop-types'
import React, {Fragment} from 'react'
import Row from 'react-bootstrap/lib/Row'
import {colors, media, text} from '../../../../styles'
import {css} from 'glamor'
import {isLittleLeagueStore} from '../store/littleLeague'

const style = {
  address: css(text.finePrint, {
    marginTop: '20px',
    textAlign: 'right'
  }),
  breadcrumbs: css({
    marginTop: '10px',
    ...media.mobile({
      marginTop: 0
    })
  }),
  licensing: css(text.finePrint, {
    color: colors.gray46,
    ...media.xs({
      '& > p': {
        margin: '10px 0 0'
      }
    })
  }),
  location: css({
    color: colors.gray46,
    display: 'block',
    fontWeight: 'normal',
    margin: 0,
    textTransform: 'none'
  }),
  title: css(text.h4, {
    letterSpacing: '0.5px',
    margin: '20px 0 5px',
    textTransform: 'none'
  })
}

const Header = ({breadcrumbs, category, store, product}) => {
  const {IsCorrectionAllowed, IsEditAllowed, LicensedStoreView, NotEndorsed} =
    store
  const licensed = LicensedStoreView && !isLittleLeagueStore(store)
  const showAddress =
    store.Address.Address1 || IsCorrectionAllowed || IsEditAllowed

  return (
    <Fragment>
      <Breadcrumb
        store={store}
        product={product}
        items={breadcrumbs}
        {...style.breadcrumbs}
      />
      <Row className="header">
        <Col xs={12} sm={12} md={9}>
          <h1 {...style.title}>
            {store.StoreName}
            {category ? `: ${category}` : ' Apparel Store'}
          </h1>
          <h5 className="hidden-xs" {...style.location}>
            {store.Address.City && `${store.Address.City}, `}
            {store.Address.State}
          </h5>
          {store.Address.Address1 && (
            <Address className="visible-xs" address={store.Address} inline />
          )}
        </Col>
        {showAddress && (
          <Col xsHidden smHidden md={3} {...style.address}>
            <div>
              <strong>School Address</strong>
              {IsCorrectionAllowed && (
                <span>
                  {' '}
                  (
                  <Link
                    href={`/store/editstore?storeid=${store.StoreID}`}
                    rel="nofollow"
                  >
                    Store Correction
                  </Link>
                  )
                </span>
              )}
              {IsEditAllowed && (
                <span>
                  {' '}
                  (
                  <Link href={`/channel/manageteam?channel=${store.StoreID}`}>
                    Edit Store
                  </Link>
                  )
                </span>
              )}
            </div>
            {store.Address.Address1 && <Address address={store.Address} />}
          </Col>
        )}
        {(licensed || NotEndorsed) && (
          <Col xs={12} {...style.licensing}>
            {licensed && <p>Officially Licensed Collegiate Merchandise</p>}
            {NotEndorsed && (
              <p>
                This store is not sponsored or endorsed by {store.SchoolName}.
              </p>
            )}
          </Col>
        )}
      </Row>
    </Fragment>
  )
}

Header.propTypes = {
  breadcrumbs: PropTypes.array,
  category: PropTypes.string,
  store: PropTypes.object.isRequired,
  product: PropTypes.object
}

export default Header
